import { Vector2 } from 'three'

const uniforms = {
  tDiffuse: { value: null },
  threholdColorLimit: { value: new Vector2() }
}

const vertex = `
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1);
}
`

const fragment = `
#define R_LUMINANCE 0.298912
#define G_LUMINANCE 0.586611
#define B_LUMINANCE 0.114478

// #define W_LIMIT 0.47059
// #define G_LIMIT 0.23529

#define W_LIMIT 0.77059
#define G_LIMIT 0.43529

uniform sampler2D tDiffuse;
uniform vec2 threholdColorLimit;
varying vec2 vUv;

void main() {
  // vec4 color = texture2D(tDiffuse, vUv);
  // float v = color.x * R_LUMINANCE + color.y * G_LUMINANCE + color.z * B_LUMINANCE;
  // if (v >= W_LIMIT) {
  //   v = 1.0;
  // } else if (G_LIMIT <= v && v < W_LIMIT) {
  //   v = 0.698;
  //   // v = 0.302;
  // } else {
  //   v = 0.0;
  // }
  // // v = 1.0; // 白
  // // v = 0.0; // 黒

  vec4 color = texture2D(tDiffuse, vUv);
  float v = color.x * R_LUMINANCE + color.y * G_LUMINANCE + color.z * B_LUMINANCE;
  if (v >= threholdColorLimit.x) {
    v = 1.0;
  } else if (threholdColorLimit.y <= v && v < threholdColorLimit.x) {
    v = 0.698;
    // v = 0.302;
  } else {
    v = 0.0;
  }

  if (color.w == 0.0) {
    gl_FragColor = vec4(vec3(v, v, v), 0.0);
  } else {
    gl_FragColor = vec4(vec3(v, v, v), 1.0);
  }

  // Spriteの解像度がうまくいかないのでモノトーンだけはひとまず原色を出すようにしている
  if (color.x == color.y && color.y == color.z) {
  //   if (color.x == 1.0 || color.x == 0.0) {
      gl_FragColor = color;
  //   }
  }
}
`

const ToneShader = { uniforms, vertex, fragment }

export { ToneShader }
